<template>
  <div>
    <p
      v-if="!showInputCheckEmailGuardian"
      class="mb-5"
      style="font-size: 0.85rem; margin-left: 16px; font-weight: light !important"
      :style="template.secondaryTheme ? 'color: white;' : ''"
    >
      {{ $t('guardian.introLine1') }}<br />
      {{ $t('guardian.introLine2') }}
    </p>
    <div v-if="!showInputCheckEmailGuardian">
      <!-- Name Input -->
      <div class="col form-group mb-4">
        <input
          ref="nameInput"
          id="guardianName"
          v-model="obj.guardian.firstName"
          class="w-100 c-input"
          :placeholder="
            !config.fullNameOneInput == true
              ? $t('guardian.firstName')
              : $t('guardian.fullName')
          "
          type="text"
        />
      </div>

      <!-- Surname Input -->
      <div v-if="!config.fullNameOneInput == true" class="col form-group mt-5">
        <input
          ref="nameInput"
          id="surname"
          v-model="obj.guardian.surname"
          class="w-100 c-input"
          :placeholder="$t('guardian.surname')"
          type="text"
        />
      </div>
    </div>

    <!-- CPF Input -->
    <div v-if="!showInputCheckEmailGuardian && requiresGuardianCpf" class="col form-group mt-5">
      <input
        ref="cpf"
        id="cpf"
        v-model="obj.guardian.cpf"
        v-mask="'###.###.###-##'"
        class="w-100 c-input"
        :placeholder="$t('guardian.cpf')"
        type="text"
        @keyup.enter="validateFields"
      />
    </div>

    <!-- E-mail Input -->
    <div v-if="!showInputCheckEmailGuardian" class="col form-group mt-5">
      <input
        id="email"
        v-model="obj.guardian.email"
        class="w-100 c-input"
        :placeholder="$t('guardian.email')"
      />
    </div>

    <!-- BirthDate Input -->
    <div v-if="!showInputCheckEmailGuardian" class="col form-group mt-5">
      <input
        ref="birthInput"
        id="birth"
        v-model="obj.guardian.birthDate"
        v-mask="'##/##/####'"
        class="w-100 c-input"
        :placeholder="$t('guardian.birthDate')"
        type="text"
        @keyup.enter="validateFields"
      />
    </div>

    <!-- Phone Input -->
    <div v-if="!showInputCheckEmailGuardian" class="col form-group mt-5">
      <input
        ref="phoneInput"
        id="phone"
        v-model="obj.guardian.phone"
        v-mask="'(##) #####-####'"
        class="w-100 c-input"
        :placeholder="$t('guardian.phone')"
        type="tel"
      />
    </div>

    <!-- Gender Input -->
    <div v-if="!showInputCheckEmailGuardian" class="col form-group mt-4">
      <label
        class="mb-1"
        :style="
          template.secondaryTheme ? 'color: white !important; font-weight: light !important;' : ''
        "
      >
        {{ $t('guardian.genderLabel') }}
      </label>

      <div class="gender-div-gap">
        <div class="gender-div">
          <input
            id="masculino"
            v-model="obj.guardian.gender"
            class="form-check-input"
            style="margin-bottom: 5px"
            type="radio"
            name="guardianGender"
            value="M"
          />
          <label
            for="masculino"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ $t('gender.male') }}
          </label>
        </div>

        <div class="gender-div">
          <input
            id="feminino"
            v-model="obj.guardian.gender"
            class="form-check-input"
            type="radio"
            name="guardianGender"
            value="F"
          />
          <label
            for="feminino"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ $t('gender.female') }}
          </label>
        </div>

        <div class="gender-div">
          <input
            id="outro"
            v-model="obj.guardian.gender"
            class="form-check-input"
            type="radio"
            name="guardianGender"
            value="N"
          />
          <label
            for="outro"
            class="gender-label"
            :style="
              template.secondaryTheme
                ? 'color: white !important; font-weight: light !important;'
                : ''
            "
          >
            {{ $t('gender.other') }}
          </label>
        </div>
      </div>
    </div>

    <!-- <div class="col form-group mt-3">
      <label
        class="mb-1"
        :style="
          template.secondaryTheme ? 'color: white !important; font-weight: light !important;' : ''
        "
      >
        Qual é o grau de parentesco?
      </label>

      <div class="ml-4 w-100 form-group form-radio left-align">
        <input
          id="father"
          v-model="degree"
          class="form-check-input mt-2 cursor-pointer"
          type="radio"
          name="degree"
          value="pai"
        />
        <label
          for="father"
          class="mt-1 ml-1 cursor-pointer"
          :style="
            template.secondaryTheme ? 'color: white !important; font-weight: light !important;' : ''
          "
        >
          Pai
        </label>

        <br />

        <input
          id="mother"
          v-model="degree"
          class="form-check-input cursor-pointer"
          type="radio"
          name="degree"
          value="mãe"
        />
        <label
          for="mother"
          class="ml-1 cursor-pointer"
          :style="
            template.secondaryTheme ? 'color: white !important; font-weight: light !important;' : ''
          "
        >
          Mãe
        </label>

        <br />

        <input
          id="other"
          v-model="degree"
          class="form-check-input cursor-pointer"
          type="radio"
          name="degree"
          value="other"
        />
        <label
          for="other"
          class="ml-1 cursor-pointer"
          :style="
            template.secondaryTheme ? 'color: white !important; font-weight: light !important;' : ''
          "
        >
          Outro
        </label>

        <br />
      </div>
    </div> -->

    <!-- <div v-if="degree == 'other'" class="col form-group mb-4">
      <input
        ref="nameInput"
        id="name"
        v-model="obj.guardian.degree"
        class="w-100 c-input"
        :placeholder="'Grau de parentesco'"
        type="text"
      />
    </div> -->

    <!-- Send Confirm Code Email Input -->
    <div v-if="showInputCheckEmailGuardian">
      <p
        style="font-size: 0.85rem; margin-left: 16px; margin-right: 16px"
        :style="template.secondaryTheme ? 'color: white;' : ''"
      >
        {{
          obj.passport
            ? 'A code has been sent to your email!'
            : $t('guardian.codeSent')
        }}
      </p>

      <div class="col form-group">
        <input
          id="emailConfirmation"
          v-model="codeToSend"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="$t('guardian.verificationCode')"
          @keyup.enter="validateFields"
        />
        <p
          :style="
            template.secondaryTheme
              ? `font-size:0.8rem; color: ${template.primaryColor}; text-align: left; color: white;`
              : `font-size:0.8rem; color: ${template.primaryColor}; text-align: left;`
          "
          class="mt-3 mr-4"
        >
          {{ $t('guardian.mandatory') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import store from '@/store/store.js'
import { loginFB } from '../../services/ServFB.js'
import { mask } from 'vue-the-mask'

const lFB = new loginFB()
export default {
  name: 'guardian',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    degree: 'Outro',
    codeToSend: '',
    toastMessage: '',
  }),
  computed: {
    ...mapState([
      'config',
      'registrationObject',
      'subdomain',
      'template',
      'showInputCheckEmailGuardian',
    ]),
    requiresGuardianCpf() {
      const iso3 = String((this.config && this.config.iso3) || '').toUpperCase()
      if (!iso3) return true
      return iso3 === 'BRA'
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  created() {
    // Create a deep copy of the object of the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    this.obj.guardian = {}
    this.setShowInputCheckEmailGuardian(false)
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
      'setShowInputCheckEmailGuardian',
      'setGuardianCreationFinished',
    ]),
    validateBirthDate(dateStr) {
      // First check for the pattern
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) return false

      // Parse the date parts to integers
      let parts = dateStr.split('/')

      let day = parseInt(parts[0], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[2], 10)

      // Check the ranges of month and year
      if (year < 1000 || year > 3000 || month == 0 || month > 12) return false

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      // Adjust for leap years
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29
      }

      // Check the range of the day
      if (day <= 0 || day > monthLength[month - 1]) return false

      // Convert the input date to a Date object
      const inputDate = new Date(year, month - 1, day)
      const today = new Date()

      // Calculate the maximum birthdate (150 years ago)
      const maxBirthDate = new Date(today)
      maxBirthDate.setFullYear(today.getFullYear() - 150)

      // Validate that the input date is within the allowed range
      if (inputDate < maxBirthDate || inputDate > today) {
        return false
      }

      return true
    },

    isOverMinimumAge(dateStr, minAge) {
      if (!this.validateBirthDate(dateStr)) {
        return false
      }

      let parts = dateStr.split('/')
      let day = parseInt(parts[0], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[2], 10)

      const birthDate = new Date(year, month - 1, day)
      const today = new Date()

      const minBirthDate = new Date(today)
      minBirthDate.setFullYear(today.getFullYear() - minAge)

      return birthDate <= minBirthDate
    },

    validateFields() {
      this.$emit('validating')
      this.clearRegistrationErrors()
      let hasErrors = false

      if (!this.obj.guardian.firstName) {
        hasErrors = true
        const firstNameMsg = this.obj.passport
          ? 'It is necessary to inform the name of the person responsible.'
          : 'É necessário informar o nome do responsável.'
        this.addRegistrationError({ msg: firstNameMsg })
        this.toastMessage = firstNameMsg
        this.makeToast('warning')
      }

      if (!this.obj.guardian.surname) {
        hasErrors = true
        const surnameMsg = this.obj.passport
          ? 'It is necessary to inform the surname.'
          : 'É necessário informar o sobrenome.'
        this.addRegistrationError({
          msg: surnameMsg,
        })
        this.toastMessage = surnameMsg
        this.makeToast('warning')
      }

      if (this.requiresGuardianCpf && !this.checkCPF(this.obj.guardian.cpf)) {
        hasErrors = true
        const cpfMsg = this.obj.passport ? 'Please provide a valid CPF.' : this.$t('guardian.cpfInvalid')
        this.addRegistrationError({
          msg: cpfMsg,
        })
        this.toastMessage = cpfMsg
        this.makeToast('warning')
      } else if (!this.requiresGuardianCpf) {
        this.obj.guardian.cpf = ''
      }

      if (!this.obj.guardian.phone) {
        hasErrors = true
        const phoneMsg = this.obj.passport
          ? 'It is necessary to provide a telephone number.'
          : 'É necessário informar um telefone.'
        this.addRegistrationError({
          msg: phoneMsg,
        })
        this.toastMessage = phoneMsg
        this.makeToast('warning')
      }

      if (!this.validatePhone(this.obj.guardian.phone)) {
        hasErrors = true
        const phoneMsg = this.obj.passport
          ? 'Please provide a valid phone number.'
          : 'Informe um telefone válido.'
        this.addRegistrationError({
          msg: phoneMsg,
        })
        this.toastMessage = phoneMsg
        this.makeToast('warning')
      }

      if (!this.obj.guardian.gender || this.obj.gender === 'g') {
        hasErrors = true
        const genderMsg = this.obj.passport
          ? 'It is necessary to inform the gender.'
          : 'É necessário informar o gênero.'
        this.addRegistrationError({
          msg: genderMsg,
        })
        this.toastMessage = genderMsg
        this.makeToast('warning')
      }

      if (!this.degree) {
        hasErrors = true
        this.addRegistrationError({
          msg: 'É necessário informar o grau de parentesco.',
        })
      }

      if (this.degree == 'other') {
        if (!this.obj.guardian.degree) {
          hasErrors = true
          this.addRegistrationError({
            msg: 'É necessário informar o grau de parentesco.',
          })
        }
      } else {
        if (this.degree) {
          this.obj.guardian.degree = this.degree
        }
      }

      if (!this.validateBirthDate(this.obj.guardian.birthDate)) {
        hasErrors = true
        const birthDateMsg = this.obj.passport
          ? 'Please provide a valid date of birth for the guardian.'
          : 'Informe uma data de nascimento válida para o responsável.'
        this.addRegistrationError({ msg: birthDateMsg })
        this.toastMessage = birthDateMsg
        this.makeToast('warning')
      } else if (!this.isOverMinimumAge(this.obj.guardian.birthDate, 18)) {
        hasErrors = true
        const ageMsg = this.obj.passport
          ? 'The person responsible must be over 18 years old.'
          : 'O responsável precisa ser maior de 18 anos.'
        this.addRegistrationError({ msg: ageMsg })
        this.toastMessage = ageMsg
        this.makeToast('warning')
      }

      if (!this.checkEmail(this.obj.guardian.email)) {
        hasErrors = true
        const warningMsg = this.obj.passport
          ? 'A valid email is required.'
          : 'É necessário um E-mail válido.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (this.showInputCheckEmailGuardian == true) {
        if (this.codeToSend.length < 5 && store.state.config.mandatoryCheck == true) {
          const warningMsg = this.obj.passport
            ? 'Incorrect code entered.'
            : 'Código informado incorreto.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          hasErrors = true
          this.toastMessage = warningMsg
          this.makeToast('warning')
        }
      }

      if (!hasErrors && this.showInputCheckEmailGuardian == true) {
        let code = this.codeToSend
        if (code.length > 5 && store.state.config.mandatoryCheck == true) {
          this.checkEmailCodeToConfirmService(code, this.obj.guardian.email)
        } else {
          if (code.length >= 0) {
            this.checkEmailCodeToConfirmService(this.codeToSend, this.obj.guardian.email)
          } else {
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          }
        }
      }

      if (!hasErrors && this.showInputCheckEmailGuardian != true) {
        this.sendEmailCodeToConfirmService(this.obj.guardian.email)
        this.setShowInputCheckEmailGuardian(true)
      }
    },
    async sendEmailCodeToConfirmService(email) {
      try {
        const owner = store.state.config.ownerId
        const name = store.state.config.name
        await lFB.sendEmailCodeToConfirm(email, 0, owner, name)
      } catch (err) {
        this.toastMessage = err
        this.makeToastError('danger')
      }
    },
    async checkEmailCodeToConfirmService(code, email) {
      try {
        const name = store.state.config.name
        await lFB.checkEmailCodeToConfirm(code, email, name).then(res => {
          let codesucess = res
          if (codesucess == 1) {
            this.obj.code = code
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
            this.setGuardianCreationFinished(true)
          } else {
            const wrongCodeMsg = this.obj.passport
              ? 'Incorrect code entered.'
              : 'Código informado incorreto.'
            this.addRegistrationError({
              msg: wrongCodeMsg,
            })
            this.toastMessage = wrongCodeMsg
            this.makeToastError('danger')
          }
        })
      } catch (err) {
        this.toastMessage = err
        this.makeToastError('danger')
      }
    },
    checkCPF(value) {
      if (!value || !value.length) return false

      let cpf = value.replace(/[^\d]/g, '')

      if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }

      let sum
      let remainder
      let i

      sum = 0

      for (i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false
      }

      sum = 0

      for (i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false
      }

      return true
    },

    validatePhone(phone) {
      return phone.length === 15
    },

    checkEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/
      return emailRegex.test(email)
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: `Atenção`,
        variant: variant,
        solid: true,
      })
    },
    makeToastError(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: `Erro`,
        variant: variant,
        solid: true,
      })
    },
  },
}
</script>
<style>
.cursor-pointer {
  cursor: pointer;
}

.form-check-input {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-right: 8px;
  align-self: initial;
  cursor: pointer;
  position: relative !important;
  margin: 0 !important;
}

.left-align {
  text-align: left;
}

.form-check-input:checked {
  background-color: var(--input-color);
}

.form-check-input:focus {
  outline: none;
}

.form-radio label {
  margin-bottom: 0.5;
}
.gender-div-gap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gender-div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gender-label {
  margin: 0 !important;
  padding-top: 2px !important;
  cursor: pointer;
}
</style>
